var Vue = require('vue'),
	Q = require('q'),
	Mapper = require('mapper'),
	_BaseServiceV2 = require('./core/_BaseServiceV2');

var MAPPERS = {
	classAssignments: new Mapper({
		ed: 'deadline',
		'opts.a': 'opts.a',
		'opts.h': 'opts.h',
		'opts.qs': 'opts.qs',
		'opts.expressqs': 'opts.expressqs',
		'opts.bok': 'opts.bok',
		'opts.v': 'opts.v',
		'opts.va': 'opts.vocabularyActivities',
		'opts.ebook': 'opts.ebook',
		'opts.sr': 'opts.sr',
		'opts.au': 'opts.au',
		'opts.ell': 'opts.ell',
		'opts.video': 'opts.video',
		'opts.challenge': 'opts.challenge',
		'opts.support': 'opts.support',
		'opts.wd': 'opts.wd',
		'opts.mm': 'opts.mm',
		'opts.decodables': 'opts.decodables'
	}),
	myList: new Mapper({
		p: 'productId',
		c: 'creationTimestamp'
	}),
	binder: new Mapper({
		u: 'url',
		p: 'productId',
		t: 'type',
		c: 'creationTimestamp'
	}),
	accountSetting: new Mapper({
		c: 'creationTimestamp'
	})
};

var ID_PROPERTY = {
	myList: 'productId'
};

function CRUDService() {
	_BaseServiceV2.call(this, 'rest');
}

CRUDService.prototype = Object.create(_BaseServiceV2.prototype);

var service = new CRUDService(),
	cache = {
		// Add null entry here to enable cache for object type
		myList: null,
		binder: null,
		accountSetting: null
	},
	pending = {},
	cacheIdToIndex = {};

for (let key in cache) {
	cacheIdToIndex[key] = {};
}

function createCacheEntry(value) {
	return new Vue({
		data: function () {
			return {
				value: value
			};
		}
	}).value;
}

module.exports = {
	read: function (name, params) {
		var pendingKey = name + JSON.stringify(params);

		if (pending[pendingKey]) {
			var deferred = Q.defer();

			pending[pendingKey].push(deferred);

			return deferred.promise;
		}

		var idProperty = ID_PROPERTY[name] || 'id';

		if (cache[name]) {
			if (!params) {
				return Q(cache[name]);
			} else if (cache[name][cacheIdToIndex[name][params[idProperty]]]) {
				return Q(cache[name][cacheIdToIndex[name][params[idProperty]]]);
			}
		}

		pending[pendingKey] = [];

		return service
			.get(name, params)
			.then(function (result) {
				var converted,
					mapper = MAPPERS[name];

				if (!params) {
					converted = [];

					if (result) {
						result.forEach(function (o) {
							var convertedObject = mapper.serverToClient(o);

							for (var key in o) {
								if (!(key in mapper.map)) {
									convertedObject[key] = o[key];
								}
							}

							converted.push(convertedObject);
						});
					}

					if (name in cache) {
						cache[name] = createCacheEntry(converted);

						converted.forEach(function (o, i) {
							cacheIdToIndex[name][o[idProperty]] = i;
						});
					}
				} else {
					converted = mapper.serverToClient(result);

					for (var key in result) {
						if (!(key in mapper.map)) {
							converted[key] = result[key];
						}
					}

					if (name in cache && converted) {
						if (cache[name]) {
							cacheIdToIndex[name][result[idProperty]] = cache[name].push(converted) - 1;
						} else {
							cache[name] = createCacheEntry([converted]);

							cacheIdToIndex[name][params[idProperty]] = 0;
						}
					}
				}

				setTimeout(function () {
					pending[pendingKey].forEach(function (d) {
						d.resolve(converted);
					});

					delete pending[pendingKey];
				}, 0);

				return converted;
			})
			.catch(function (error) {
				setTimeout(function () {
					pending[pendingKey].forEach(function (d) {
						d.reject(error);
					});

					delete pending[pendingKey];
				}, 0);

				throw error;
			});
	},

	create: function (name, params) {
		var idProperty = ID_PROPERTY[name] || 'id',
			mapper = MAPPERS[name];

		return service.post(name, mapper.clientToServer(params)).then(function (result) {
			var converted = mapper.serverToClient(result);

			for (var key in result) {
				if (!(key in mapper.map)) {
					converted[key] = result[key];
				}
			}

			if (name in cache && converted) {
				if (!cache[name]) {
					cache[name] = createCacheEntry([converted]);

					cacheIdToIndex[name][converted[idProperty]] = 0;
				} else {
					cacheIdToIndex[name][converted[idProperty]] = cache[name].push(converted) - 1;
				}
			}

			return converted;
		});
	},

	update: function (name, id, params) {
		var idProperty = ID_PROPERTY[name] || 'id';

		return service.put(name + '/' + id, params).then(function (result) {
			if (name in cache) {
				if (!cache[name]) {
					cache[name] = createCacheEntry([params]);

					cacheIdToIndex[name][params[idProperty]] = 0;
				} else {
					var entryIndex = cacheIdToIndex[name] && cacheIdToIndex[name][id];

					if (typeof entryIndex === 'number') {
						var entry = cache[name][entryIndex];

						if (entry === null || typeof entry === 'undefined') {
							entry = params;
							cache[name][entryIndex] = entry;
						} else {
							for (var key in params) {
								var newValue = params[key];

								if (newValue === '') {
									delete entry[key];
								} else {
									entry[key] = newValue;
								}
							}
						}
					} else {
						cacheIdToIndex[name][params[idProperty]] = cache[name].push(params) - 1;
					}
				}
			}

			return params;
		});
	},

	remove: function (name, id) {
		return service.del(name + '/' + id).then(function (result) {
			if (cache[name]) {
				var entryIndex = cacheIdToIndex[name] && cacheIdToIndex[name][id];

				if (typeof entryIndex === 'number') {
					cache[name].splice(entryIndex, 1);

					delete cacheIdToIndex[name][id];

					var idProperty = ID_PROPERTY[name] || 'id';

					for (var i = entryIndex, l = cache[name].length; i < l; i++) {
						cacheIdToIndex[name][cache[name][i][idProperty]]--;
					}
				}
			}

			return result;
		});
	}
};
